import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { BRSR_CONFIG } from "./config";

import WelcomeBannerContainer from "@components/main/co2/hub/WelcomeBanner";
import CollectData from "@components/main/co2/hub/CollectData";
import Reports from "@components/main/co2/hub/Reports";
import Overview from "@components/main/co2/hub/Overview";
import { Box, Grid } from "@components/base";

const BrsrHubPage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <WelcomeBannerContainer
          title={t(BRSR_CONFIG.welcomeBanner.titleKey)}
          text={t(BRSR_CONFIG.welcomeBanner.textKey)}
          color={BRSR_CONFIG.welcomeBanner.color}
          icon={BRSR_CONFIG.welcomeBanner.icon}
        />
        <Grid size={12}>
          <CollectData
            formBaseType={BRSR_CONFIG.formBaseType}
            titleKey={t(BRSR_CONFIG.collectData.titleKey)}
            descriptionKey={t(BRSR_CONFIG.collectData.descriptionKey)}
            color={BRSR_CONFIG.collectData.color}
            icon={BRSR_CONFIG.collectData.icon}
            buttonTextKey={t(BRSR_CONFIG.collectData.buttonTextKey)}
            noFormsTextKey={t(BRSR_CONFIG.collectData.noFormsTextKey)}
          />
        </Grid>
        <Grid size={12}>
          <Reports
            formBaseType={BRSR_CONFIG.formBaseType}
            title={t(BRSR_CONFIG.reports.titleKey)}
            type={BRSR_CONFIG.reports.type}
            noReportsText={t(BRSR_CONFIG.reports.noReportsTextKey)}
            fillFormText={t(BRSR_CONFIG.reports.fillFormTextKey)}
          />
        </Grid>
        <Grid size={12}>
          <Overview
            title={t(BRSR_CONFIG.overview.titleKey)}
            dashboardPath={BRSR_CONFIG.overview.dashboardPath}
            viewDashboardText={t(BRSR_CONFIG.overview.viewDashboardTextKey)}
            reportPageId={BRSR_CONFIG.overview.reportPageId}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BrsrHubPage;
